import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class ChangeStatusFilter extends Action<StorymapState> {
    public static ACTION_TYPE = 'ChangeStatusFilter';

    public constructor(public statusKey: number) {
        super(ChangeStatusFilter.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: ChangeStatusFilter): void => {
    if (state.filterState.statusKeys.includes(action.statusKey)) {
        state.filterState.statusKeys = state.filterState.statusKeys.filter((x) => x !== action.statusKey);
    } else {
        state.filterState.statusKeys.push(action.statusKey);
    }
};

//@ts-ignore
registerReducer(ChangeStatusFilter.ACTION_TYPE, reducer);
